import styled from "@emotion/styled"

export const HeaderSectionWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	div {
		&.sectionHeader {
			display: flex;
			flex-direction: column;
			gap: 16px;
			p {
				margin: 0;
				&:first-child {
					color: #130080;
					font-weight: 700;
					font-size: 20px;
					line-height: 24px;
					letter-spacing: 0%;
				}
				&:last-child {
					color: #adbac7;
					font-weight: 400;
					font-size: 16px;
					line-height: 19.2px;
					letter-spacing: 0%;
				}
			}
		}
	}
`
